import { RenderType } from '../../../enums/render-type.enum';

/** What happened in a viewer frame. */
export interface RenderFrameEvents {
  cameraMoved: boolean;
  /** A tool moved, rotated or scaled scene objects, so culling ran again. */
  objectsMoved: boolean;
  /** The pointer moved, so the object under it was picked. */
  pointerMoved: boolean;
  /** The picked object changed, so the hover highlight moved. */
  hoverChanged: boolean;
}

/**
 * Names the work a frame did for the page's mode indicator. The viewer redraws on its own; the modes tell a
 * camera move (Transform) from a tool edit (UpdateItems), the first still frame after motion (UpdateRaycast),
 * a pick (UpdateSelect) and a hover change (UpdateOver).
 */
export class RenderModesHandler {
  private moving: boolean = false;

  public update(events: RenderFrameEvents): RenderType {
    if (events.cameraMoved || events.objectsMoved) {
      this.moving = true;
      return events.objectsMoved ? RenderType.UpdateItems : RenderType.Transform;
    }
    if (this.moving) {
      this.moving = false;
      return RenderType.UpdateRaycast;
    }
    if (events.hoverChanged) {
      return RenderType.UpdateOver;
    }
    return events.pointerMoved ? RenderType.UpdateSelect : RenderType.None;
  }
}
